import { Post_Save_Edit_Output_history_Api } from "../../Apis/user/ApiConfig";
import {
  POST_SAVE_EDIT_OUTPUT_HISTOTY_ERROR,
  POST_SAVE_EDIT_OUTPUT_HISTOTY_REQUEST,
  POST_SAVE_EDIT_OUTPUT_HISTOTY_SUCCESS,
} from "../../Types/user/Types";
import Swal from "sweetalert2";
import { Get_Output_History_list_Action_Handler } from "../../../Redux/Actions/user/OutputListEditHistoryRunQa";

export const Save_Edit_Output_History_Success = (res) => {
  return {
    type: POST_SAVE_EDIT_OUTPUT_HISTOTY_SUCCESS,
    payload: res,
  };
};
export const Save_Edit_Output_History_Error = (error) => {
  return {
    type: POST_SAVE_EDIT_OUTPUT_HISTOTY_ERROR,
    error: error,
  };
};

export const Save_Edit_Output_History_Request = (res) => {
  return {
    type: POST_SAVE_EDIT_OUTPUT_HISTOTY_REQUEST,
    payload: res,
  };
};

export const Save_Edit_Output_History_Action_Handler = (
  values,
  QaId,
  action_run_id
) => {
  return (dispatch) => {
    dispatch(Save_Edit_Output_History_Request());
    try {
      Post_Save_Edit_Output_history_Api(values, QaId, action_run_id)
        .then((res) => {
          const errorMessage = res?.data?.message;
          if (res) {
            if (res && res.data && res?.status === 201) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Edited Output Saved Successfully!",
                showConfirmButton: false,
                timer: 1500,
              });
              dispatch(Save_Edit_Output_History_Success(res.data));
              dispatch(
                Get_Output_History_list_Action_Handler(QaId, action_run_id)
              );
            } else {
              dispatch(Save_Edit_Output_History_Error(errorMessage));
            }
          } else {
            dispatch(Save_Edit_Output_History_Error(errorMessage));
          }
        })
        .catch((err) => {
          dispatch(Save_Edit_Output_History_Error("Something Went Wrong!!!"));
        });
    } catch (err) {
      dispatch(Save_Edit_Output_History_Error(err));
    }
  };
};
